import * as React from 'react';

import {LinkedEntity} from 'shells/linked-entity/linked-entity';

import type {EventFragmentSparse} from 'nutshell-graphql-types';

import {TimelineBanner} from './timeline-banner';

import styles from './timeline-banner.module.css';

type Props = {
    event: EventFragmentSparse;
    newValue: string | null;
    newValueMode: string;
};

export const VALUE_MODE_PRODUCT = '1';
export const VALUE_MODE_MANUAL = '2';

export function TimelineBannerLeadValue(props: Props) {
    const {event, newValue, newValueMode} = props;

    const getAction = (value: string | null, mode: string, name: string, htmlUrl: string) => {
        const linkedEntity = (
            <strong>
                <LinkedEntity
                    type='leads'
                    useEntityColor={true}
                    shouldClientRoute={true}
                    name={name}
                    htmlUrl={htmlUrl}
                    allowWrap={true}
                    displayInline={true}
                    greenLeads={true}
                />
            </strong>
        );

        switch (mode) {
            case VALUE_MODE_PRODUCT:
                return value ? (
                    <span>
                        reset value of&nbsp;
                        {linkedEntity}&nbsp;to total of products worth <strong>{value}</strong>
                    </span>
                ) : (
                    <span>
                        reset value of&nbsp;
                        {linkedEntity}&nbsp;to empty total of products
                    </span>
                );
            case VALUE_MODE_MANUAL:
                return value ? (
                    <span>
                        manually set value of&nbsp;
                        {linkedEntity}&nbsp;to <strong>{value}</strong>
                    </span>
                ) : (
                    // Case shouldn't happen as manual values are set to
                    // explicit 0, but keeping for safety
                    <span>
                        manually set value of 
                        {linkedEntity}
                    </span>
                );
            default:
                return <></>;
        }
    };

    /**
     * We need to include this check, even though we are only passing an event
     * with a payload.__typename of 'Lead' because Apollo doesn't generate a specific
     * enough type when using a union type (like the TimelineEventPayload).
     * See this issue for more detail:
     * https://github.com/apollographql/apollo-tooling/issues/1223
     */
    if (event.payload.__typename === 'Lead') {
        const name = event.payload.name;
        const htmlUrl = event.payload.htmlUrl;

        return (
            <TimelineBanner
                id={event.id}
                iconVariant='lead-value'
                timestamp={event.changeTime}
                actor={event.actor}
                action={getAction(newValue, newValueMode, name, htmlUrl)}
            />
        );
    }

    return null;
}
